import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Section = function Section(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      title = _ref.title;
  var getClassName = getClassNameFactory("SiteHeaderSection");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: columns ? "".concat(columns, "col") : null
    })
  }, title && /*#__PURE__*/React.createElement("h3", {
    className: getClassName({
      descendantName: "title"
    })
  }, title), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "children"
    })
  }, children));
};

Section.displayName = "SiteHeader.Section";
export default Section;